import * as React from 'react';
import {PureComponent, createElement, createRef, ReactNode} from 'react';
import ZoomIn from "./icons/ZoomIn";
import ZoomOut from "./icons/ZoomOut";
import Home from './icons/Home';
import Location from './icons/Location-2';

interface IProps {
    className?: string
    onZoomIn: () => void
    onZoomOut: () => void
    onViewReset: () => void
    onLocateUser: () => void
    isLocatingUser: boolean
}

export default class MapControls extends PureComponent<IProps, {}> {

    _containerRef = createRef();

    _renderButton(type: string, label: string, callback: any, children: ReactNode, classname='') {
        return createElement('button', {
            key: type,
            className: `mapboxgl-ctrl-icon mapboxgl-ctrl-${type} ${classname}`,
            type: 'button',
            title: label,
            onClick: callback,
            children,
        });
    }

    render () {
        const {className, onZoomIn, onZoomOut, onViewReset, onLocateUser, isLocatingUser} = this.props;

        return createElement('div', {
            className: `mapboxgl-ctrl mapboxgl-ctrl-group ${className}`,
            ref: this._containerRef
        }, [
            this._renderButton('zoomIn', 'Zoom In', onZoomIn,
                <ZoomIn/>
            ),
            this._renderButton('zoomOut', 'Zoom Out', onZoomOut,
                <ZoomOut/>
            ),
            this._renderButton('Home', 'Reset Zoom', onViewReset,
                <Home/>
            ),
            this._renderButton('Location', 'Show My Location', onLocateUser,
                <Location/>,
                isLocatingUser ? 'data-ctrl-icon active' : ''
            ),
        ]);
    }
}
